import { addMissingAlt } from './add-alt'

if (document.querySelector('img')) {
  addMissingAlt()
}
